(function (window) {
    "use strict";
    function defineCurrencyHelper() {
        var currencyHelper = {};
        currencyHelper.numberToCurrency = function(value, currencySymbol){
            var number = Number(value);
            if(number){
                var currency = currencySymbol || "R";
                // return currency + number.toFixed(2);
                var formattedNumber = number.toLocaleString("en-US", { minimumFractionDigits:2, maximumFractionDigits:2 });
                return currency + formattedNumber;
            }
            return "R0.00";
        };
        currencyHelper.numberToCurrencyWithFourDecimalPlaces = function (value, currencySymbol){
            var number = Number(value);
            if(number){
                var currency = currencySymbol || "R";
                var formattedNumber = number.toLocaleString("en-US", { minimumFractionDigits:4, maximumFractionDigits:4 });
                return currency + formattedNumber;
            }
            return "R0.0000";
        };
        currencyHelper.roundToTwoDecimalPlaces = function(value){
            var number = Number(value);
            if(number){
                return Number(number.toFixed(2));
            }
            return 0.00;
        };
        currencyHelper.roundToFourDecimalPlaces = function(value){
            var number = Number(value);
            if(number){
                return Number(number.toFixed(4));
            }
            return 0.0000;
        };
        return currencyHelper;
    }
    //define globally if it doesn't already exist
    if (typeof (currencyHelper) === "undefined") {
        window.currencyHelper = defineCurrencyHelper();
    } else {
        console.log("currencyHelper already defined.");
    }
})(window);